import Show from '../show'

const defaultParams = {
  time_period: '30'
}

function PcDashboard() {
  return (
    <Show
      title="Pcard Dashboard"
      dashboardKey="pc_dashboards"
      showYear={false}
      defaultParams={defaultParams}
    />
  )
}

export default PcDashboard
